<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term2">
      <div class="term2-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="code" label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column width="320" prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="uom" label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value5" label="本年数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 371">
                <span class="text-center">{{ sum ? sum : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 381">
                <span class="text-center">{{ fuzhu ? fuzhu : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 393">
                <span class="text-center">{{ sheshi ? sheshi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 310">
                <span class="text-center">{{ yiqi_yuanzhi ? yiqi_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 3122">
                <span class="text-center">{{ equip_yuanzhi ? equip_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 3125">
                <span class="text-center">{{ equip_price ? equip_price : scope.row.value5 }}</span>
              </section>
              <section
                v-else-if="scope.row.equipstandardopt.viewOnly[4] == false"
              >
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value5"
                  disabled
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value5, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value5"
                  disabled
                  placeholder=""
                  @input="handleNumber(scope.row.value5)"
                  @change="
                    handleValue(
                      scope.row.value5,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
              </section>
              <section v-else>
                <span class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="value6" label="本年面积/金额">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 381">
                <span class="text-center">{{ fuzhu_area ? fuzhu_area : scope.row.value6 }}</span>
              </section>
              <section v-else>
                <el-input
                  v-if="scope.row.equipstandardopt.viewOnly[5] == false"
                  v-model="scope.row.value6"
                  disabled
                  placeholder=""
                  @input="handleNumber(scope.row.value6)"
                  @change="
                    handleValue0(
                      scope.row.value6,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                  @focus="
                    handleValue0(
                      scope.row.value6,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
                <span v-else class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  name: 'ComTerm12',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      t: null,
      form: [],
      jsonForm: {},
      other: {
        num1: null,
        num2: null,
        num3: null,
        num4: null
      },
      sum: null,
      fuzhu: null,
      fuzhu_area: null,
      sheshi: null,
      yiqi_yuanzhi: null,
      equip_yuanzhi: null,
      equip_price: null,
      pushArr: true
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleOthers()
    if (localStorage.getItem('form3')) {
      this.form = JSON.parse(localStorage.getItem('form3'))
    }
  },
  methods: {
    handleOthers() {
      var a = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num1,
        37,
        137,
        '3.7 图书馆(室)管理人员情况',
        '',
        '',
        {
          code: 37,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 137,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var b = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num2,
        38,
        153,
        '3.8 图书馆(室)用房状况 ',
        '',
        '',
        {
          code: 38,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 153,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var c = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num3,
        39,
        162,
        '3.9 图书馆(室)藏书状况 ',
        '',
        '',
        {
          code: 39,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 162,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var d = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num4,
        312,
        171,
        '3.12 读者服务情况',
        '',
        '',
        {
          code: 312,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 171,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''
      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue0(x, y, z, a) {
      var isExit = false
      var obj = {}
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value6 = z.value6
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      var q = this.handleValueModle0(
        38101,
        38102,
        38103,
        38104,
        0,
        0,
        0,
        0, 0, 0,
        this.fuzhu_area,
        381,
        154,
        '3.8.1 阅览室情况',
        '包括教师阅览室和学生阅览室；如果学校藏书室和阅览室在一起时，只作藏书室统计',
        '个、m²',
        {
          code: 381,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 154,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '38101+38102+38103+38104'
      )
      this.fuzhu_area = q
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = null
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = z.value5
      obj.value6 = null
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value5 = z.value5
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      console.log(this.form, 'this.form')

      var a = this.handleValueModle(
        37101,
        37102,
        0,
        0,
        0,
        0,
        0,
        0,
        0, 0,
        this.sum,
        371,
        138,
        '3.7.1 图书馆(室)管理人员合计 ',
        '指从事图书馆（室）管理工作的人员',
        '人',
        {
          code: 371,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 138,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '37101+37102=37103+37104+37105+37106=37107+37108+37109=37110+37111+37112+37113'
      )
      this.sum = a

      var b = this.handleValueModle(
        38101,
        38102,
        38103,
        38104,
        0,
        0,
        0,
        0, 0, 0,
        this.fuzhu,
        381,
        154,
        '3.8.1 阅览室情况',
        '包括教师阅览室和学生阅览室；如果学校藏书室和阅览室在一起时，只作藏书室统计',
        '个、m²',
        {
          code: 381,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 154,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '38101+38102+38103+38104'
      )
      this.fuzhu = b

      var c = this.handleValueModle(
        391,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.sheshi,
        393,
        165,
        '3.9.5 生均纸质图书册数',
        ' ',
        '册',
        {
          code: 393,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 165,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '391/111'
      )
      this.sheshi = c

      var d = this.handleValueModle(
        31001,
        31002,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.yiqi_yuanzhi,
        310,
        168,
        '3.10 当年图书报刊购置经费合计 ',
        '指实际用于购买图书（包括电子图书）、报纸、杂志的金额',
        '元 ',
        {
          code: 310,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 168,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '31001+31002'
      )
      this.yiqi_yuanzhi = d

      var e = this.handleValueModle(
        3121,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.equip_yuanzhi,
        3122,
        173,
        '3.12.2 生均借阅量',
        ' ',
        '册/学年',
        {
          code: 3122,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 173,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '3121/111'
      )
      this.equip_yuanzhi = e

      var f = this.handleValueModle(
        3124,
        391,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.equip_price,
        3125,
        176,
        '3.12.5 纸质图书流通率',
        '“纸质图书流通率”从装备配备的角度评价图书采购质量、受欢迎程度。学年纸质图书外借册数÷纸质图书总册数×100%',
        '%',
        {
          code: 3125,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 176,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '3124/391'
      )
      this.equip_price = f

      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle0(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9, code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value6')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value6')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value6')
      var others = this.arrayLookup(this.form, 'code', code4, 'value6')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value6')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value6')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value6')
      var heigh11 = this.arrayLookup(this.form, 'code', code8, 'value6')
      var pupil11 = this.arrayLookup(this.form, 'code', code9, 'value6')
      var junior11 = this.arrayLookup(this.form, 'code', code10, 'value6')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(heigh11) +
        Number(pupil11) +
        Number(junior11)
      if (value) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = value
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value6 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    handleValueModle(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9,
      code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value5')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value5')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value5')
      var others = this.arrayLookup(this.form, 'code', code4, 'value5')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value5')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value5')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value5')
      var others1 = this.arrayLookup(this.form, 'code', code8, 'value5')
      var pupil2 = this.arrayLookup(this.form, 'code', code9, 'value5')
      var junior2 = this.arrayLookup(this.form, 'code', code10, 'value5')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(others1) +
         Number(pupil2) +
        Number(junior2)
      if (code == 393 || code == 3122) {
        var num2 = localStorage.getItem('111')
        var value1 = Number(pupil) / Number(num2)
        value = value1.toFixed(1)
      } else if (code == 3125) {
        var value1 = Number(pupil) / Number(junior)
        value = value1.toFixed(3)
      }
      if (
        code == 37 ||
        code == 38 ||
        code == 39 ||
        code == 312
      ) {
        value = null
      }
      if (
        value ||
        code == 37 ||
        code == 38 ||
        code == 39 ||
        code == 312
      ) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = value
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value5 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      for (let i = 0; i < this.form.length; i++) {
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = null
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = this.form[i].value5
        const value6 = this.form[i].value6
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form3')
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if ((this.form.length == this.data.length)) {
          this.$message.success('已保存成功！')
          localStorage.setItem('form3', JSON.stringify(this.form))
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term2 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term2-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
